import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthModalComponent } from './auth/auth-modal.component';

/**
 * Layout del marketplace: renderiza la página activa y monta el modal de auth una
 * sola vez por encima del outlet, para que cualquier página (o el guard/interceptor)
 * pueda abrirlo sin sacar al usuario de su contexto. Ver SPEC-016.
 */
@Component({
  selector: 'app-marketplace-shell',
  standalone: true,
  imports: [RouterOutlet, AuthModalComponent],
  template: `
    <router-outlet></router-outlet>
    <app-auth-modal></app-auth-modal>
  `,
})
export class MarketplaceShellComponent {}
